import React, { useState } from 'react';
import Currency from './Currency';
import Process from './Process';
import Role from './Role';
import Payment from './Payment';
import { ArrowDownRightIcon, ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/24/solid';
import Metrials from './Metrials';

const Settings = () => {
  const [selectedSetting, setSelectedSetting] = useState(null);

  const settingsData = [
    { title: 'Currency' },
    { title: 'Process' },
    { title: 'Role' },
    { title: 'Payment' },
    { title: 'Metrials' },
  ];

  const handleSettingClick = (title) => {
    setSelectedSetting(title);
  };

  const renderSettingContent = () => {
    switch (selectedSetting) {
      case 'Currency':
        return <Currency/>;
      case 'Process':
        return  <Process/>;
      case 'Role':
        return  <Role/>;
      case 'Payment':
        return  <Payment/>;
      case 'Metrials':
        return  <Metrials/>;
      default:
        return null;
    }
  };

  return (
    <div className="p-4 min-h-screen">

      {selectedSetting ? (
        // Show selected setting's content
        <div>
          <button
            onClick={() => setSelectedSetting(null)}
            className="text-black flex space-x-4 mb-4 poppins-medium text-sm"
          >
            <ArrowLeftIcon className='h-5 w-5'/> Back to Settings
          </button>
          <div className="p-6 bg-white shadow-lg rounded-xl">
            <h2 className="text-xl font-semibold mb-3 text-gray-700">{selectedSetting} Settings</h2>
            {renderSettingContent()}
          </div>
        </div>
      ) : (
        // Show list of settings
      <>
            
            <h1 className="text-3xl poppins-bold   text-gray-800 mb-8">Settings</h1><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {settingsData.map((setting, index) => (
                <button
                  key={index}
                  onClick={() => handleSettingClick(setting.title)}
                  className="block bg-white hover:bg-gray-50 shadow-lg rounded-xl p-6 transition-all duration-200 transform"
                >
                  <h2 className="text-xl  poppins-semibold mb-3 text-left text-gray-700 poppins-bold group-hover:text-gray-600">
                    {setting.title}
                  </h2>
                  <span className="text-gray-800 flex poppins-semibold text-sm  ">View {setting.title} settings <ArrowRightIcon className='h-5 w-5 ml-1'/></span>
                </button>
              ))}
            </div></>
      )}
    </div>
  );
};

export default Settings;
